var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('avue-form',{ref:"form",attrs:{"option":_vm.option,"upload-before":_vm.uploadBefore,"upload-after":_vm.uploadAfter},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }